import React from "react";

export const NoData = () => (
  <svg
    width="90"
    height="90"
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="89"
      height="89"
      rx="19.5"
      fill="#F7F7F7"
      stroke="#E8E8E8"
    />
    <path
      d="M23.6097 55V42.4H25.9137V55H23.6097ZM34.0618 55.216C32.7898 55.216 31.6978 54.946 30.7858 54.406C29.8738 53.854 29.1718 53.092 28.6798 52.12C28.1878 51.136 27.9418 50.002 27.9418 48.718C27.9418 47.434 28.1878 46.3 28.6798 45.316C29.1718 44.332 29.8738 43.564 30.7858 43.012C31.6978 42.46 32.7898 42.184 34.0618 42.184C35.5738 42.184 36.8098 42.562 37.7698 43.318C38.7418 44.062 39.3478 45.112 39.5878 46.468H37.0498C36.8938 45.784 36.5578 45.25 36.0418 44.866C35.5378 44.47 34.8658 44.272 34.0258 44.272C32.8618 44.272 31.9498 44.668 31.2898 45.46C30.6298 46.252 30.2998 47.338 30.2998 48.718C30.2998 50.098 30.6298 51.184 31.2898 51.976C31.9498 52.756 32.8618 53.146 34.0258 53.146C34.8658 53.146 35.5378 52.966 36.0418 52.606C36.5578 52.234 36.8938 51.724 37.0498 51.076H39.5878C39.3478 52.372 38.7418 53.386 37.7698 54.118C36.8098 54.85 35.5738 55.216 34.0618 55.216ZM47.5313 55.216C46.2713 55.216 45.1673 54.94 44.2193 54.388C43.2833 53.836 42.5453 53.074 42.0053 52.102C41.4773 51.118 41.2133 49.984 41.2133 48.7C41.2133 47.416 41.4773 46.288 42.0053 45.316C42.5453 44.332 43.2833 43.564 44.2193 43.012C45.1673 42.46 46.2713 42.184 47.5313 42.184C48.7793 42.184 49.8773 42.46 50.8253 43.012C51.7733 43.564 52.5113 44.332 53.0393 45.316C53.5673 46.288 53.8313 47.416 53.8313 48.7C53.8313 49.984 53.5673 51.118 53.0393 52.102C52.5113 53.074 51.7733 53.836 50.8253 54.388C49.8773 54.94 48.7793 55.216 47.5313 55.216ZM47.5313 53.146C48.7313 53.146 49.6853 52.75 50.3933 51.958C51.1133 51.166 51.4733 50.08 51.4733 48.7C51.4733 47.32 51.1133 46.234 50.3933 45.442C49.6853 44.65 48.7313 44.254 47.5313 44.254C46.3313 44.254 45.3713 44.65 44.6513 45.442C43.9313 46.234 43.5713 47.32 43.5713 48.7C43.5713 50.08 43.9313 51.166 44.6513 51.958C45.3713 52.75 46.3313 53.146 47.5313 53.146ZM55.8656 55V42.4H58.1696L64.0916 51.274V42.4H66.3956V55H64.0916L58.1696 46.144V55H55.8656Z"
      fill="#61605B"
    />
  </svg>
);

export const Upload = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ri-upload-line" clipPath="url(#clip0_1168_6022)">
      <g id="Group">
        <path
          id="Vector"
          d="M2.5 15.8337H17.5V17.5003H2.5V15.8337ZM10.8333 4.85699V14.167H9.16667V4.85699L4.1075 9.91699L2.92917 8.73866L10 1.66699L17.0708 8.73782L15.8925 9.91616L10.8333 4.85866V4.85699Z"
          fill="black"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1168_6022">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NavIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
  >
    <path d="M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z" />
  </svg>
);

export const Dashboard = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="list 1">
      <g id="Group 2">
        <rect
          id="Rectangle"
          opacity="0.7"
          x="1.605"
          y="2.605"
          width="5.79"
          height="5.74092"
          rx="0.605"
          stroke={props.color || "#5A6474"}
          strokeWidth="1.21"
        />
        <rect
          id="Rectangle Copy 9"
          x="1"
          y="11.9297"
          width="7"
          height="6.95094"
          rx="1.21"
          fill={props.color || "#5A6474"}
        />
        <rect
          id="Rectangle Copy 8"
          x="11"
          y="2"
          width="7"
          height="6.95092"
          rx="1.21"
          fill={props.color || "#5A6474"}
        />
        <rect
          id="Rectangle Copy 10"
          x="11"
          y="11.9297"
          width="7"
          height="6.95094"
          rx="1.21"
          fill={props.color || "#5A6474"}
        />
      </g>
    </g>
  </svg>
);

export const Edit = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1516 8.08702L4.70244 15.4475L1.00003 15.4254L1.02219 11.723L8.47134 4.36245M12.1516 8.08702L14.8227 5.44773L14.8243 5.44607C15.192 5.08283 15.3761 4.90085 15.446 4.69022C15.5075 4.50463 15.5087 4.30442 15.4494 4.1181C15.3821 3.90684 15.2004 3.72285 14.8376 3.3557L13.2369 1.73569C12.8725 1.36696 12.6902 1.1825 12.4793 1.11256C12.2938 1.051 12.0935 1.0499 11.9072 1.10913C11.6956 1.17646 11.5115 1.35844 11.1432 1.72233L11.1425 1.72316L8.47134 4.36245M12.1516 8.08702L8.47134 4.36245"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Delete = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 7.875V13.125"
      stroke="#F72626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.75 7.875V13.125"
      stroke="#F72626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 4.375H15"
      stroke="#F72626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.75 4.375H8H13.25V14C13.25 15.4498 12.0748 16.625 10.625 16.625H5.375C3.92526 16.625 2.75 15.4498 2.75 14V4.375Z"
      stroke="#F72626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.375 2.625C5.375 1.6585 6.1585 0.875 7.125 0.875H8.875C9.84152 0.875 10.625 1.6585 10.625 2.625V4.375H5.375V2.625Z"
      stroke="#F72626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Search = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.7688 11.4311C12.7033 11.3656 12.3918 11.6865 12.3264 11.621C12.2444 11.539 12.3264 10.9886 12.3264 10.9886C13.1116 9.91753 13.5323 8.62269 13.5264 7.29466C13.5114 3.82804 10.7076 1.02009 7.24098 1.00006C5.58202 0.992558 3.98896 1.64885 2.81669 2.82272C1.64443 3.9966 0.990325 5.59056 1.00011 7.24951C1.01509 10.7164 3.81922 13.5247 7.28613 13.5447C8.61958 13.5505 9.91914 13.1249 10.9909 12.3315L10.9955 12.328C10.9955 12.328 11.5012 12.2493 11.5799 12.328C11.6388 12.387 11.352 12.6847 11.4156 12.7484C12.8425 14.1761 15.3722 16.7071 15.3722 16.7071C15.6089 16.9554 15.9615 17.0559 16.2934 16.9696C16.6254 16.8834 16.8845 16.6241 16.9705 16.292C17.0564 15.96 16.9556 15.6075 16.7072 15.371C16.7072 15.371 14.0816 12.7444 12.7688 11.4311ZM7.28165 12.2898C4.50828 12.2738 2.26501 10.0275 2.25284 7.2541C2.24535 5.92712 2.76867 4.65221 3.70631 3.71317C4.64395 2.77414 5.91808 2.24892 7.24508 2.25443C10.0185 2.27039 12.2617 4.51671 12.2739 7.29011C12.2814 8.61709 11.7581 9.892 10.8204 10.831C9.88278 11.7701 8.60865 12.2953 7.28165 12.2898Z"
      fill="#39322E"
    />
    <path
      d="M12.7688 11.4311L12.5919 11.6078L12.7688 11.4311ZM12.3264 11.621L12.1496 11.7978L12.3264 11.621ZM12.3264 10.9886L12.1248 10.8407L12.0882 10.8906L12.0791 10.9517L12.3264 10.9886ZM13.5264 7.29466L13.2764 7.29574V7.29576L13.5264 7.29466ZM7.24098 1.00006L7.24243 0.750068L7.24211 0.750066L7.24098 1.00006ZM1.00011 7.24951L1.25011 7.24843L1.2501 7.24804L1.00011 7.24951ZM7.28613 13.5447L7.28468 13.7947L7.28504 13.7947L7.28613 13.5447ZM10.9909 12.3315L11.1396 12.5324L11.1409 12.5315L10.9909 12.3315ZM10.9955 12.328L10.957 12.081L10.8953 12.0906L10.8454 12.128L10.9955 12.328ZM11.5799 12.328L11.7567 12.1513L11.5799 12.328ZM11.4156 12.7484L11.5924 12.5717L11.4156 12.7484ZM15.3722 16.7071L15.5532 16.5346L15.5491 16.5304L15.3722 16.7071ZM16.7072 15.371L16.5303 15.5478L16.5348 15.5522L16.7072 15.371ZM7.28165 12.2898L7.28021 12.5398L7.28061 12.5398L7.28165 12.2898ZM2.25284 7.2541L2.50283 7.25301L2.50283 7.25269L2.25284 7.2541ZM7.24508 2.25443L7.24652 2.00444L7.24612 2.00443L7.24508 2.25443ZM12.2739 7.29011L12.0239 7.2912L12.0239 7.29152L12.2739 7.29011ZM12.9456 11.2544C12.8564 11.1651 12.7467 11.1679 12.6942 11.1763C12.6414 11.1847 12.5964 11.2052 12.5688 11.2191C12.5117 11.2478 12.4497 11.2904 12.4073 11.3191C12.3555 11.3542 12.3233 11.3755 12.3015 11.3865C12.2897 11.3924 12.2991 11.3858 12.3221 11.3821C12.3447 11.3785 12.4303 11.3714 12.5032 11.4443L12.1496 11.7978C12.2388 11.887 12.3485 11.8842 12.4009 11.8759C12.4537 11.8674 12.4987 11.847 12.5263 11.8331C12.5834 11.8043 12.6454 11.7618 12.6878 11.733C12.7396 11.6979 12.7718 11.6766 12.7936 11.6657C12.8054 11.6597 12.7961 11.6664 12.773 11.67C12.7504 11.6736 12.6648 11.6807 12.5919 11.6078L12.9456 11.2544ZM12.5032 11.4443C12.5427 11.4838 12.5483 11.5217 12.5457 11.5109C12.545 11.5082 12.5428 11.4964 12.5413 11.4724C12.5384 11.4252 12.5402 11.3612 12.545 11.2913C12.5498 11.223 12.5569 11.1562 12.563 11.1059C12.5661 11.0809 12.5688 11.0604 12.5707 11.0463C12.5717 11.0392 12.5724 11.0338 12.5729 11.0302C12.5732 11.0284 12.5734 11.0271 12.5735 11.0263C12.5736 11.0259 12.5736 11.0256 12.5736 11.0255C12.5736 11.0254 12.5737 11.0253 12.5737 11.0253C12.5737 11.0253 12.5737 11.0253 12.5737 11.0253C12.5737 11.0253 12.5736 11.0253 12.5736 11.0253C12.5736 11.0254 12.5736 11.0254 12.3264 10.9886C12.0791 10.9517 12.0791 10.9517 12.0791 10.9518C12.0791 10.9518 12.0791 10.9518 12.0791 10.9518C12.0791 10.9519 12.0791 10.9519 12.0791 10.952C12.079 10.9521 12.079 10.9523 12.079 10.9524C12.0789 10.9528 12.0789 10.9533 12.0788 10.954C12.0786 10.9552 12.0783 10.957 12.078 10.9593C12.0773 10.9638 12.0764 10.9703 12.0753 10.9785C12.0731 10.9948 12.07 11.0179 12.0667 11.0458C12.0599 11.1013 12.0517 11.1771 12.0462 11.2567C12.0408 11.3347 12.0374 11.4237 12.0422 11.5028C12.0446 11.5419 12.0494 11.5866 12.06 11.6297C12.0686 11.6647 12.0896 11.7378 12.1496 11.7978L12.5032 11.4443ZM12.528 11.1364C13.3449 10.0222 13.7825 8.67513 13.7764 7.29355L13.2764 7.29576C13.2821 8.57026 12.8784 9.81289 12.1248 10.8407L12.528 11.1364ZM13.7764 7.29358C13.7609 3.68987 10.8461 0.770882 7.24243 0.750068L7.23954 1.25006C10.569 1.26929 13.262 3.9662 13.2764 7.29574L13.7764 7.29358ZM7.24211 0.750066C5.5164 0.742258 3.85924 1.42495 2.6398 2.64607L2.99359 2.99938C4.11869 1.87274 5.64765 1.24286 7.23985 1.25006L7.24211 0.750066ZM2.6398 2.64607C1.42036 3.86718 0.739936 5.52528 0.750113 7.25099L1.2501 7.24804C1.24071 5.65584 1.86849 4.12602 2.99359 2.99938L2.6398 2.64607ZM0.750111 7.25059C0.765686 10.8546 3.68069 13.7739 7.28468 13.7947L7.28757 13.2947C3.95775 13.2754 1.2645 10.5783 1.25011 7.24843L0.750111 7.25059ZM7.28504 13.7947C8.67242 13.8007 10.0245 13.3579 11.1396 12.5324L10.8421 12.1305C9.81374 12.8919 8.56673 13.3002 7.28721 13.2947L7.28504 13.7947ZM11.1409 12.5315L11.1455 12.528L10.8454 12.128L10.8409 12.1315L11.1409 12.5315ZM10.9955 12.328C11.0339 12.5751 11.0339 12.5751 11.0339 12.5751C11.0339 12.5751 11.0339 12.5751 11.0339 12.5751C11.0338 12.5751 11.0338 12.5751 11.0338 12.5751C11.0338 12.5751 11.0339 12.5751 11.0339 12.5751C11.0341 12.575 11.0343 12.575 11.0347 12.575C11.0354 12.5748 11.0366 12.5747 11.0382 12.5744C11.0414 12.5739 11.0463 12.5732 11.0527 12.5723C11.0656 12.5705 11.0843 12.5679 11.1071 12.565C11.153 12.5592 11.2139 12.5524 11.2762 12.5479C11.34 12.5433 11.3977 12.5417 11.4396 12.5443C11.4495 12.545 11.4572 12.5457 11.463 12.5465C11.469 12.5473 11.4715 12.548 11.4711 12.5479C11.4708 12.5478 11.4692 12.5474 11.4666 12.5465C11.4641 12.5456 11.4599 12.5441 11.4545 12.5416C11.445 12.5371 11.4246 12.5264 11.403 12.5048L11.7567 12.1513C11.6983 12.0929 11.628 12.0718 11.5932 12.063C11.5512 12.0524 11.5083 12.0477 11.4711 12.0453C11.3961 12.0406 11.3125 12.0439 11.2401 12.0492C11.1661 12.0545 11.0957 12.0625 11.0443 12.0689C11.0185 12.0722 10.9971 12.0752 10.9819 12.0773C10.9744 12.0784 10.9684 12.0793 10.9641 12.0799C10.962 12.0803 10.9603 12.0805 10.9591 12.0807C10.9585 12.0808 10.9581 12.0809 10.9577 12.0809C10.9575 12.0809 10.9574 12.081 10.9573 12.081C10.9572 12.081 10.9571 12.081 10.9571 12.081C10.9571 12.081 10.957 12.081 10.957 12.081C10.957 12.081 10.957 12.081 10.9955 12.328ZM11.403 12.5048C11.3287 12.4304 11.3369 12.3432 11.3399 12.3235C11.3432 12.3011 11.3494 12.2916 11.3441 12.3027C11.3344 12.3232 11.3158 12.3533 11.2843 12.4035C11.2587 12.4442 11.2203 12.5048 11.1948 12.5615C11.1823 12.5892 11.1644 12.6339 11.1584 12.6862C11.1524 12.7388 11.155 12.8414 11.2388 12.9252L11.5924 12.5717C11.6603 12.6396 11.6579 12.7189 11.6552 12.7428C11.6525 12.7664 11.6461 12.777 11.6507 12.7668C11.6592 12.7479 11.6769 12.7185 11.7077 12.6695C11.7325 12.6299 11.7706 12.5705 11.7961 12.5166C11.8084 12.4905 11.8269 12.4476 11.8344 12.3974C11.8415 12.3498 11.8458 12.2404 11.7567 12.1513L11.403 12.5048ZM11.2388 12.9252C11.9522 13.639 12.9414 14.6287 13.7522 15.4399C14.1576 15.8455 14.5184 16.2065 14.7778 16.4661C14.9076 16.5959 15.012 16.7003 15.0839 16.7723C15.1199 16.8083 15.1478 16.8362 15.1667 16.8551C15.1761 16.8645 15.1833 16.8717 15.1881 16.8765C15.1906 16.879 15.1923 16.8807 15.1936 16.882C15.1942 16.8826 15.1946 16.883 15.1949 16.8834C15.1951 16.8835 15.1952 16.8836 15.1953 16.8837C15.1953 16.8838 15.1954 16.8838 15.1954 16.8838C15.1954 16.8838 15.1954 16.8838 15.3722 16.7071C15.5491 16.5304 15.549 16.5304 15.549 16.5304C15.549 16.5303 15.549 16.5303 15.5489 16.5303C15.5489 16.5303 15.5487 16.53 15.5486 16.5299C15.5483 16.5296 15.5478 16.5291 15.5472 16.5285C15.546 16.5273 15.5442 16.5255 15.5418 16.5231C15.5369 16.5182 15.5297 16.5111 15.5203 16.5016C15.5014 16.4827 15.4736 16.4548 15.4376 16.4188C15.3656 16.3468 15.2612 16.2424 15.1315 16.1126C14.872 15.853 14.5112 15.492 14.1058 15.0864C13.295 14.2752 12.3059 13.2855 11.5924 12.5717L11.2388 12.9252ZM15.1913 16.8796C15.4905 17.1936 15.9365 17.3206 16.3563 17.2116L16.2306 16.7277C15.9865 16.7911 15.7272 16.7172 15.5532 16.5346L15.1913 16.8796ZM16.3563 17.2116C16.7761 17.1026 17.1038 16.7746 17.2125 16.3547L16.7284 16.2294C16.6653 16.4735 16.4747 16.6643 16.2306 16.7277L16.3563 17.2116ZM17.2125 16.3547C17.3212 15.9348 17.1937 15.4889 16.8795 15.1899L16.5348 15.5522C16.7175 15.726 16.7916 15.9852 16.7284 16.2294L17.2125 16.3547ZM16.7072 15.371C16.884 15.1943 16.884 15.1943 16.8839 15.1943C16.8839 15.1943 16.8839 15.1942 16.8838 15.1942C16.8832 15.1936 16.8842 15.1945 16.8835 15.1938C16.8831 15.1935 16.8827 15.1931 16.8821 15.1924C16.8808 15.1912 16.8789 15.1892 16.8764 15.1867C16.8714 15.1817 16.8639 15.1742 16.8542 15.1645C16.8346 15.1449 16.8058 15.1161 16.7686 15.0789C16.6942 15.0045 16.5865 14.8968 16.4532 14.7634C16.1865 14.4966 15.8173 14.1272 15.4071 13.7168C14.5866 12.896 13.602 11.911 12.9456 11.2544L12.5919 11.6078C13.2483 12.2645 14.2329 13.2495 15.0534 14.0703C15.4637 14.4807 15.8329 14.8501 16.0996 15.1169C16.2329 15.2502 16.3406 15.358 16.415 15.4324C16.4521 15.4696 16.481 15.4984 16.5005 15.518C16.5103 15.5278 16.5178 15.5352 16.5228 15.5402C16.5253 15.5427 16.5272 15.5446 16.5284 15.5459C16.529 15.5465 16.5296 15.547 16.5299 15.5473C16.5299 15.5474 16.53 15.5475 16.5301 15.5475C16.5301 15.5476 16.5302 15.5476 16.5302 15.5477C16.5303 15.5477 16.5303 15.5477 16.5303 15.5478C16.5303 15.5478 16.5303 15.5478 16.7072 15.371ZM7.28309 12.0398C4.64679 12.0246 2.51441 9.88932 2.50283 7.25301L2.00284 7.2552C2.01562 10.1657 4.36976 12.523 7.28021 12.5398L7.28309 12.0398ZM2.50283 7.25269C2.49572 5.99243 2.99273 4.78163 3.88322 3.88982L3.52941 3.53653C2.54462 4.52278 1.99498 5.8618 2.00284 7.25551L2.50283 7.25269ZM3.88322 3.88982C4.77371 2.998 5.98377 2.49919 7.24404 2.50443L7.24612 2.00443C5.85239 1.99864 4.51419 2.55027 3.52941 3.53653L3.88322 3.88982ZM7.24364 2.50443C9.87994 2.51959 12.0123 4.65489 12.0239 7.2912L12.5239 7.28901C12.5111 4.37853 10.157 2.02118 7.24652 2.00444L7.24364 2.50443ZM12.0239 7.29152C12.031 8.55177 11.534 9.76258 10.6435 10.6544L10.9973 11.0077C11.9821 10.0214 12.5318 8.68241 12.5239 7.2887L12.0239 7.29152ZM10.6435 10.6544C9.75302 11.5462 8.54296 12.045 7.28269 12.0398L7.28061 12.5398C8.67434 12.5456 10.0125 11.9939 10.9973 11.0077L10.6435 10.6544Z"
      fill="#39322E"
    />
  </svg>
);

export const Add = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.8 0.8C8.8 0.358176 8.44184 0 8 0C7.55816 0 7.2 0.358176 7.2 0.8V7.2H0.8C0.358176 7.2 0 7.55816 0 8C0 8.44184 0.358176 8.8 0.8 8.8H7.2V15.2C7.2 15.6418 7.55816 16 8 16C8.44184 16 8.8 15.6418 8.8 15.2V8.8H15.2C15.6418 8.8 16 8.44184 16 8C16 7.55816 15.6418 7.2 15.2 7.2H8.8V0.8Z"
      fill="#39322E"
    />
  </svg>
);
export const Down = (props: any) => (
  <svg
    width={props.size || "24"}
    height={props.size || "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="chevron-down (2) 1">
      <path
        id="Vector"
        d="M6 9L12 15L18 9"
        stroke={props.color || "#121212"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const Category = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2667 8.53333H13.8667V16H0V2.13333H7.46667V3.73333L11.2 0L16 4.8L12.2667 8.53333ZM7.71667 4.8L11.2 8.28333L14.6833 4.8L11.2 1.31667L7.71667 4.8ZM7.46667 5.86667V8.53333H10.1333L7.46667 5.86667ZM1.06667 8.53333H6.4V3.2H1.06667V8.53333ZM6.4 9.6H1.06667V14.9333H6.4V9.6ZM7.46667 9.6V14.9333H12.8V9.6H7.46667Z"
      fill="black"
    />
  </svg>
);
export const Product = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_901_22900)">
      <g clip-path="url(#clip1_901_22900)">
        <path
          d="M2.64339 13.9584C2.30873 13.3797 2.04858 12.761 1.86914 12.117C2.25968 11.9184 2.58765 11.6156 2.81679 11.2421C3.04592 10.8687 3.16729 10.4391 3.16745 10.001C3.16762 9.56284 3.04657 9.13319 2.81772 8.75956C2.58886 8.38594 2.26111 8.0829 1.87072 7.88398C2.22859 6.58999 2.90997 5.4084 3.85068 4.45052C4.21809 4.68939 4.64442 4.82194 5.0825 4.83351C5.52057 4.84509 5.95331 4.73523 6.33282 4.5161C6.71233 4.29696 7.0238 3.9771 7.23278 3.59191C7.44176 3.20672 7.54009 2.77122 7.51689 2.3336C8.81689 1.99764 10.181 1.99818 11.4808 2.33519C11.4578 2.77279 11.5563 3.20823 11.7654 3.59331C11.9746 3.97839 12.2862 4.2981 12.6658 4.51707C13.0453 4.73603 13.4781 4.84571 13.9161 4.83397C14.3542 4.82222 14.7805 4.68951 15.1478 4.45052C15.6061 4.9176 16.0131 5.44881 16.3551 6.04177C16.6978 6.63473 16.9543 7.25302 17.1293 7.88319C16.7388 8.08182 16.4108 8.38461 16.1817 8.75806C15.9525 9.13152 15.8312 9.56108 15.831 9.99922C15.8308 10.4374 15.9519 10.867 16.1807 11.2406C16.4096 11.6143 16.7373 11.9173 17.1277 12.1162C16.7699 13.4102 16.0885 14.5918 15.1478 15.5497C14.7804 15.3108 14.354 15.1783 13.9159 15.1667C13.4779 15.1551 13.0451 15.265 12.6656 15.4841C12.2861 15.7032 11.9746 16.0231 11.7657 16.4083C11.5567 16.7935 11.4584 17.229 11.4816 17.6666C10.1816 18.0026 8.81742 18.002 7.51768 17.665C7.54068 17.2274 7.44215 16.792 7.23301 16.4069C7.02388 16.0218 6.71227 15.7021 6.33269 15.4831C5.95311 15.2642 5.52035 15.1545 5.0823 15.1662C4.64425 15.178 4.21798 15.3107 3.85068 15.5497C3.3828 15.0723 2.97715 14.5376 2.64339 13.9584ZM7.12422 14.1136C7.96784 14.6002 8.60214 15.3811 8.90547 16.3065C9.30051 16.3437 9.69714 16.3445 10.0922 16.3073C10.3957 15.3817 11.0303 14.6008 11.8742 14.1144C12.7175 13.6265 13.7113 13.4672 14.6648 13.6671C14.8944 13.3441 15.0923 12.9997 15.257 12.6395C14.6074 11.9139 14.2485 10.974 14.2492 10.0001C14.2492 9.0026 14.6213 8.07081 15.257 7.36069C15.0912 7.0006 14.8924 6.65661 14.6633 6.3331C13.7103 6.53285 12.7172 6.37386 11.8742 5.8866C11.0306 5.40002 10.3963 4.61913 10.093 3.69369C9.69793 3.65648 9.30131 3.65569 8.90626 3.6929C8.60274 4.61847 7.96814 5.39938 7.12422 5.88581C6.28093 6.37373 5.28714 6.53302 4.3336 6.3331C4.10446 6.65633 3.9062 7.00037 3.74143 7.36069C4.39105 8.0863 4.74992 9.02619 4.74922 10.0001C4.74922 10.9976 4.37714 11.9294 3.74143 12.6395C3.90726 12.9996 4.10603 13.3436 4.33518 13.6671C5.28812 13.4674 6.28126 13.6264 7.12422 14.1136ZM9.49922 12.3751C8.86933 12.3751 8.26524 12.1249 7.81984 11.6795C7.37445 11.2341 7.12422 10.63 7.12422 10.0001C7.12422 9.37022 7.37445 8.76612 7.81984 8.32073C8.26524 7.87533 8.86933 7.6251 9.49922 7.6251C10.1291 7.6251 10.7332 7.87533 11.1786 8.32073C11.624 8.76612 11.8742 9.37022 11.8742 10.0001C11.8742 10.63 11.624 11.2341 11.1786 11.6795C10.7332 12.1249 10.1291 12.3751 9.49922 12.3751ZM9.49922 10.7918C9.70919 10.7918 9.91055 10.7084 10.059 10.5599C10.2075 10.4114 10.2909 10.2101 10.2909 10.0001C10.2909 9.79014 10.2075 9.58878 10.059 9.44031C9.91055 9.29185 9.70919 9.20844 9.49922 9.20844C9.28926 9.20844 9.0879 9.29185 8.93943 9.44031C8.79096 9.58878 8.70756 9.79014 8.70756 10.0001C8.70756 10.2101 8.79096 10.4114 8.93943 10.5599C9.0879 10.7084 9.28926 10.7918 9.49922 10.7918Z"
          fill="white"
        />
        <circle cx="9.5" cy="10" r="2.5" fill="white" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_901_22900">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
      <clipPath id="clip1_901_22900">
        <rect
          width="19"
          height="19"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);